module.exports = __webpack_public_path__ + "static/bash-9f025a91dc0e9bc2023b379fe4282a69.jpg";